// Version check utility - forces refresh when version changes
// UPDATE THIS VERSION WITH EVERY DEPLOYMENT!
const APP_VERSION = '202611030901';

export const checkVersion = () => {
  const storedVersion = localStorage.getItem('app_version');
  
  if (storedVersion && storedVersion !== APP_VERSION) {
    console.log('New app version detected! Old:', storedVersion, 'New:', APP_VERSION);
    
    // Update stored version
    localStorage.setItem('app_version', APP_VERSION);
    
    // Force unregister old service workers and reload
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(reg => {
          reg.unregister();
          console.log('Unregistered old service worker');
        });
      }).then(() => {
        // Clear all caches
        if ('caches' in window) {
          caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
            console.log('Cleared all caches');
          });
        }
      }).then(() => {
        // Force reload after cleanup
        setTimeout(() => {
          window.location.reload(true);
        }, 500);
      });
    } else {
      window.location.reload(true);
    }
    
    return false; // Indicates reload will happen
  }
  
  if (!storedVersion) {
    localStorage.setItem('app_version', APP_VERSION);
  }
  
  return true;
};

export default checkVersion;
